document.addEventListener("DOMContentLoaded", function(event) {
  let animationExecuted = false; // Variable, um den Zustand der Animation zu verfolgen

  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function animateEffect1() {
    if (animationExecuted) return; // Stoppe die Animation, wenn sie bereits ausgeführt wurde

    const effect1 = document.getElementById('effect-1');
    const effect1Number = document.getElementById('effect-1-number');
    const effect2 = document.getElementById('effect-2');
    const effect2Number = document.getElementById('effect-2-number');

    if (isElementInViewport(effect1)) {
      animationExecuted = true; // Setze die Variable, um anzuzeigen, dass die Animation ausgeführt wurde

      effect1.animate(
        [
          { height: '1px' }, 
          { height: '100px' }
        ], 
        {
          duration: 1500,
          easing: 'ease-in-out',
          fill: 'forwards'
        }
      );

      effect1Number.animate(
        [
          { opacity: 0 }, 
          { opacity: 1 }
        ], 
        {
          duration: 750,
          delay: 750,
          easing: 'ease-in-out',
          fill: 'forwards'
        }
      );

      effect2.animate(
        [
          { height: '1px' }, 
          { height: '175px' }
        ], 
        {
          duration: 1750,
          delay: 1000,
          easing: 'ease-in-out',
          fill: 'forwards'
        }
      );

      effect2Number.animate(
        [
          { opacity: 0 }, 
          { opacity: 1 }
        ], 
        {
          duration: 750,
          delay: 1750,
          easing: 'ease-in-out',
          fill: 'forwards'
        }
      );

      window.removeEventListener('scroll', animateEffect1); // Entferne den Event-Listener nach der Animation
    }
  }

  window.addEventListener('scroll', function() {
    animateEffect1();
  });
});